const config = {
  API_ORIGIN: process.env.API_ORIGIN || 'http://localhost:9000',
  PLACES_KEY:
    process.env.PLACES_KEY || 'AIzaSyC72-DivjbSHgX1C7zg27zXREe0PKnwkhQ',
};

export default config;
